<template>
    <div style="padding:20px">
        <div >
            <a-input v-model:value="queryParam.queryTxt" style="width:300px" placeholder="请输入任务编号 / 店铺名称 / 商家手机号" />
            <a-select placeholder="任务状态"
            v-model:value="queryParam.status" allowClear
            style="width: 120px;margin-left: 20px;"
            >
                <a-select-option :value="0">待支付</a-select-option>
                <a-select-option :value="2">进行中</a-select-option>
                <a-select-option :value="3">已完成</a-select-option>
            </a-select>
            <a-select placeholder="任务类型"
            v-model:value="queryParam.taskType" allowClear
            style="width: 120px;margin-left: 20px;"
            >
                <a-select-option value="1">普通单</a-select-option>
                <a-select-option value="2">隔日单</a-select-option>
                <a-select-option value="3">预售单</a-select-option>
            </a-select>
            <a-range-picker  :showToday="true" :placeholder="['开始日期', '结束日期']" style="margin-left:20px" v-model:value="queryParam.createTimes"  format="YYYY/MM/DD" />
            <a-button :loading="loading" @click="query(1)" style="float:right;margin-right:20px" type="primary">
                <template #icon><SearchOutlined /></template>
                搜索
            </a-button>
        </div>
        <div style="margin-top:20px">
            <a-table :loading="loading"  :scroll="{ y: tableHeight }"  @change="handleTableChange" :pagination="pagination" :dataSource="list" :columns="columns" >
                <template #bodyCell="{ column, text ,record}">
                    <template v-if="column.key === 'taskType'">
                        <a-tag color="processing" v-if="record.IsNextDay">隔日单</a-tag>
                        <a-tag color="processing" v-else-if="record.IsPreSale">预售单</a-tag>
                        <a-tag color="processing" v-else>普通单</a-tag>
                    </template>
                    <template v-else-if="column.key === 'img'" >
                        <a-image
                            style="width:100px;height:100px"
                            :src="text"
                        />
                    </template>
                    <template v-else-if="column.key === 'code'" >
                        <a @click="getDetail(record)">{{text}}</a>
                    </template>
                    <template v-else-if="column.key === 'title'" >
                        <a target="_blank" :href="record.Url">{{record.Title}}</a>
                    </template>
                    <template v-else-if="column.key === 'time'" >
                        <span style="font-weight:600">
                        {{record.StartHour.toFixed(2)}} - {{record.EndHour.toFixed(2)}}
                        </span>
                    </template>
                    <template v-else-if="column.key === 'status'" >
                        <a-tag  v-if="text==0" color="error">待支付</a-tag>
                        <a-tag  v-else-if="text==2" color="processing">进行中</a-tag>
                        <a-tag  v-else color="success">已完成</a-tag>
                    </template>
                    <template v-else-if="column.key === 'expectedOrderCount'" >
                        <a-tag color="#2db7f5" >{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'orderCount'" >
                        <a-tag color="#f56c6c" v-if="text<record.ExpectedOrderCount">{{text}}</a-tag>
                        <a-tag color="#87d068" v-else>{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'ask'" >
                        <a-tooltip placement="bottom">
                            <template #title>
                                <div>进店方式：{{record.KeyType==0?'关键字':record.KeyType==1?'口令':'扫码'}}</div>
                                <div>性别要求：{{record.SwipeGender==0?'不限':record.KeyType==1?'男':'女'}}</div>
                                <div>特殊要求：{{record.Remark}}</div>
                            </template>
                            <a-tag style="cursor:pointer;" color="default">{{record.ExpectedOverTime.split(' ')[0]}}</a-tag>
                        </a-tooltip>
                    </template>
                    <template v-else-if="column.key === 'shopType'" >
                        <a-tag color="#2db7f5" v-if="text==1">淘宝</a-tag>
                        <a-tag color="#2db7f5" v-else-if="text==2">京东</a-tag>
                        <a-tag color="#2db7f5" v-else-if="text==3">拼多多</a-tag>
                        <a-tag color="#2db7f5" v-else-if="text==5">阿里巴巴</a-tag>
                        <a-tag color="#2db7f5" v-else>抖音</a-tag>
                    </template>
                    <template v-else-if="column.key === 'action'">
                        <a-button :loading="operateing" v-if="record.Status==2&&!record.IsTop" @click="top(record)" style="margin-left:10px"  type="dashed" shape="circle">
                            <template  #icon><to-top-outlined /></template>
                        </a-button>
                        <a-button :loading="operateing" v-else-if="record.Status==2&&record.IsTop" @click="top(record)" style="margin-left:10px"  type="dashed" shape="circle">
                            <template  #icon><download-outlined /></template>
                        </a-button>
                    </template>
                </template>
                
            </a-table>
        </div>

        <a-drawer
        height="600"
    title="计划详情"
    placement="bottom"
    :visible="visible"
    @close="visible=false"
    >
    <a-table :loading="loadingDetail"  :pagination="false" :dataSource="details" :columns="detailColumns" >
                <template #bodyCell="{ column, text }">
                    <template v-if="column.key === 'num'" >
                        <a-tag color="#2db7f5" >{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'price'" >
                        <span style="font-weight:600">
                            ￥ {{text.toFixed(2)}}
                        </span>
                    </template>
                </template>
            </a-table>
    </a-drawer>
    </div>
</template>
<script>
import {  ref } from 'vue';
import { taskGetReq,taskGetDetailReq,taskTopReq } from '@/request.js';
import { message} from 'ant-design-vue';

import dayjs from 'dayjs';

// import { useRouter } from 'vue-router';
// import { message } from 'ant-design-vue';
import { SearchOutlined,ToTopOutlined,DownloadOutlined} from '@ant-design/icons-vue';
function formatDate(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
}
export default {
    components: {
        SearchOutlined,ToTopOutlined,DownloadOutlined
    },
    setup(){
        const operateing=ref(false);
        const loadingDetail=ref(false);
        const visible=ref(false);
        const details=ref([]);
        const tableHeight=ref(0);
        tableHeight.value=document.documentElement.clientHeight-260;
        const loading=ref(false);
        const pagination=ref({
            total: 0,
            pageSize: 20,
            showSizeChanger: false,
            showTotal: total => `共 ${total} 条`,  
        });
        const list=ref([]);
        const queryParam=ref({
            queryTxt:"",
            createTimes:[dayjs(formatDate(new Date()), "YYYY/MM/DD"), dayjs(formatDate(new Date()), "YYYY/MM/DD")],
        })
        const getDetail=(record)=>{
            visible.value=true;
            loadingDetail.value=true;
            taskGetDetailReq({taskId:record.Id},(res)=>{
                loadingDetail.value=false;
                details.value=res.Result;
            })
        }
        const top=(record)=>{
            operateing.value=true;
            taskTopReq({taskId:record.Id},(res)=>{
                if(res.IsSuccess){
                    record.IsTop=!record.IsTop;
                    if(record.IsTop){
                        message.success("置顶成功");
                    }else{
                        message.success("取消置顶成功");
                    }
                    
                }else{
                    message.error(res.Message);
                }
                operateing.value=false;
            })
        }
        const query=(index)=>{
            loading.value=true;
            taskGetReq({
                pIndex:index,
                pSize:pagination.value.pageSize,
                queryTxt:queryParam.value.queryTxt,
                status:queryParam.value.status?parseInt(queryParam.value.status):-1,
                taskType:queryParam.value.taskType,
                createTimes:queryParam.value.createTimes==null?'[]':JSON.stringify(queryParam.value.createTimes)
            },(res)=>{
                list.value=res.Result;
                pagination.value.total=res.TotalCount;
                loading.value=false;
            })
        };
        const handleTableChange=(e)=>{
            query(e.current);
        };
        query(1);
        return{
            top,
            operateing,
            details,
            loadingDetail,
            visible,
            getDetail,
            tableHeight,
            loading,
            handleTableChange,
            queryParam,
            list,
            query,
            pagination,
            columns: [
                {
                    title: '店铺类型',
                    dataIndex: 'ShopType',
                    key: 'shopType',
                },
                {
                    title: '任务编号',
                    dataIndex: 'Code',
                    key: 'code',
                },
                {
                    title: '所属代理',
                    dataIndex: 'AgentName',
                    key: 'agentName',
                },
                {
                    title: '商家名称',
                    dataIndex: 'MemberName',
                    key: 'MemberName',
                },
                {
                    title: '店铺名称',
                    dataIndex: 'ShopName',
                    key: 'shopName',
                },
                {
                    title: '主图',
                    dataIndex: 'Img',
                    key: 'img',
                },
                {
                    title: '商品标题',
                    key: 'title',
                },
                {
                    title: '任务类型',
                    key: 'taskType',
                },
                {
                    title: '商家要求',
                    key: 'ask',
                },
                {
                    title: '开始-结束',
                    key: 'time',
                },
                {
                    title: '单数',
                    dataIndex:"ExpectedOrderCount",
                    key: 'expectedOrderCount',
                },
                {
                    title: '已完成',
                    dataIndex:"OrderCount",
                    key: 'orderCount',
                },
                {
                    title: '状态',
                    dataIndex:"Status",
                    key: 'status',
                },
                {
                    title: '状态',
                    key: 'action',
                },
            ],
            detailColumns: [
                {
                    title: '关键词',
                    dataIndex: 'KeyWords',
                    key: 'keyWords',
                },
                {
                    title: '拍下件数',
                    dataIndex: 'BuyNum',
                    key: 'buyNum',
                },
                {
                    title: '规格',
                    dataIndex: 'Spec',
                    key: 'spec',
                },
                {
                    title: '下单价格',
                    dataIndex: 'Price',
                    key: 'price',
                },
                {
                    title: '发布单数',
                    dataIndex: 'Num',
                    key: 'num',
                },
            ],
        }
    }
}
</script>
<style scoped>
.remark{
    text-overflow:ellipsis;white-space:nowrap; overflow:hidden;width:100px;cursor:pointer
}
</style>